import qs from 'query-string';

import { OLD_VERSION_TO_NEW_VERSION_PATHS } from './constants';

interface QueryParams {
  [key: string]: string | string[] | undefined;
}

/**
 * 如果是 edu.net 的域名，返回 edu.net 的 API地址
 * @returns
 */
export const getAPIBaseUrl = (api: string | undefined) => {
  if (!api) {
    return '';
  }
  const isEduUrl = globalThis?.location?.href?.includes?.('.wukongedu.net');
  return isEduUrl ? api.replace('.wukongacademy.com', '.wukongedu.net') : api;
};

/**
 * 去除url上的某个查询参数
 * @param url
 * @param param
 * @returns
 */
export const removeQueryParam = (url: string, param: string) => {
  const parsedUrl = new URL(url);
  parsedUrl.searchParams.delete(param);
  return parsedUrl.toString();
};

/**
 * 解析 URL 查询参数
 * @param url - 可选的 URL 字符串，如果不提供则使用当前页面 URL
 * @returns 解析后的查询参数对象
 */
export const getQueryParams = (url?: string): QueryParams => {
  try {
    // 如果提供了 URL，使用 URL 对象解析
    if (url) {
      const urlObj = new URL(url);
      return qs.parse(urlObj.search.slice(1)) as QueryParams;
    }

    // 在浏览器环境下使用 window.location
    if (typeof window !== 'undefined') {
      return qs.parse(window.location.search.slice(1)) as QueryParams;
    }

    return {};
  } catch (error) {
    console.error('解析 URL 参数失败:', error);
    return {};
  }
};

/**
 * 解码 base64 字符串
 * @param str - 需要解码的 base64 字符串
 * @returns 解码后的字符串
 */
export const decodeBase64 = (str: string) => {
  if (!str) {
    return '';
  }
  try {
    // const bytes = Uint8Array.from(window.atob(str), (c) => c.charCodeAt(0));
    // return new TextDecoder('utf-8').decode(bytes);
    return window.atob(str);
  } catch (error) {
    console.error('Base64 解码失败:', error);
    return str;
  }
};

/**
 * 根据url获取当前域名
 * @returns
 */
export const getCurrentDomain = (domain: string | undefined) => {
  if (!domain) {
    return '';
  }

  // 只有线上环境才进行域名替换逻辑
  if (process.env.NEXT_PUBLIC_STAGE === 'prod') {
    return window.location.href.includes('edu.net')
      ? domain.replace('sch.com', 'edu.net')
      : domain.replace('edu.net', 'sch.com');
  }

  // 非线上环境直接返回传入的域名
  return domain;
};

export const getCurrentUrlInfoInClient = () => {
  const lang = window?.location?.pathname?.startsWith('/zh/') ? 'zh' : 'en';
  const pathname = window?.location?.pathname
    ?.replace('/zh/', '/')
    ?.replace('/en/', '/');
  const search = window?.location?.search;

  return { pathname, lang, search };
};

/**
 * 切换学员中心版本
 */
export const switchVersion = ({
  addSwitchParam = true,
}: { addSwitchParam?: boolean } = {}) => {
  const newVersionDomain = getCurrentDomain(
    process.env.NEXT_PUBLIC_AUTH_REDIRECT_URI,
  );
  const { pathname, lang, search } = getCurrentUrlInfoInClient();
  const newPathname =
    OLD_VERSION_TO_NEW_VERSION_PATHS[
      pathname as keyof typeof OLD_VERSION_TO_NEW_VERSION_PATHS
    ] || '/home';
  const switchParam = search?.includes('?')
    ? '&switch-version=true'
    : '?switch-version=true';

  globalThis?.location?.replace?.(
    `${newVersionDomain}/${lang}${newPathname}${search}${addSwitchParam ? switchParam : ''}`,
  );
};
